import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch, useFieldArray } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import PopupModel from "../popupmodel/PopupModel";
import Images from "../../assests/Images";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const AddProduct = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      addProduct: [
        {
          productNameEnglish: "",
          productImage: "",
          discountOnUnitPrice: "",
          offerSelectFromTo: "",
          unitPrice: "",
          quantity: "",
          actualUnitPrice: "",
          stock: "Available",
          quantityType: "",
          otherQuantityType: "",
          hsnCode: "",
          gstAmount: "",
          highLevelCustomer: "",
          midLevelCustomer: "",
          lowLevelCustomer: "",
          others: "",
          productFor: "",
          mrpPrice: "",
          manufacturingDate: "",
          expiryDate: "",
          companyName: "",
          companyAddress: "",
          gstNumber: "",
        },
      ],
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "addProduct",
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [popupType, setPopupType] = useState({
    type: "",
    data: "",
  });

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const { quantityType, addProduct } = watch();

  // POST API START
  const { mutate, isLoading: postLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_HOST}/products/addProduct`,
          postData
        );

        return response.data;
      } catch (error) {
        console.error("Error in mutation function:", error);
        throw error;
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add product",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        // Check if it's an Axios error and status is 409
        if (axios.isAxiosError(error) && error.response?.status === 409) {
          const conflictMessage =
            error?.response?.data || "Product already exists.";
          alert(conflictMessage);
        } else {
          alert("Failed to add Product. Please try again.");
        }
      },
    }
  );
  //

  // UPDATE API
  const { mutate: updateApi, isLoading: putLoading } = useMutation(
    async (postData) => {
      try {
        const response = await axios.put(
          `${process.env.REACT_APP_HOST}/products/${state?.id}`,
          postData
        );
        return response.data;
      } catch (error) {
        console.error("Error updating product:", error);
        throw error; // re-throw to trigger onError
      }
    },
    {
      onSuccess: () => {
        setPopupType({
          type: "add product",
        });
        setIsModalOpen(true);
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        alert("Failed to update the Product. Please try again.");
      },
    }
  );

  // SETVALUE FOR STATE VALUE
  // useEffect(() => {
  //   setValue("productNameEnglish", state?.productNameEnglish || "");
  //   setValue("hsnCode", state?.hsnCode || "");
  //   setValue("unitPrice", state?.unitPrice || 0);
  //   setValue("quantity", state?.quantity || 0);
  //   setValue("quantityType", state?.quantityType || "");
  //   setValue("otherQuantityType", state?.otherQuantityType || "");
  //   setValue("gstAmount", state?.gstAmount || null);
  //   setValue("stock", state?.stock || "");
  //   setValue("productFor", state?.productFor || "");
  //   setValue("highLevelCustomer", state?.highLevelCustomer || "");
  //   setValue("midLevelCustomer", state?.midLevelCustomer || "");
  //   setValue("lowLevelCustomer", state?.lowLevelCustomer || "");
  //   setValue("others", state?.others || "");
  // }, [state, setValue]);

  useEffect(() => {
    if (state?.id) {
      setValue(
        "addProduct.0.productNameEnglish",
        state?.productNameEnglish || ""
      );
      setValue("addProduct.0.hsnCode", state?.hsnCode || "");
      // setValue("addProduct.0.unitPrice", state?.unitPrice || "");
      // setValue("addProduct.0.quantity", state?.quantity || "");
      // setValue("addProduct.0.quantityType", state?.quantityType || "");
      setValue("addProduct.0.productFor", state?.productFor || "");
      setValue("addProduct.0.gstAmount", state?.gstAmount || "");
      setValue("addProduct.0.companyName", state?.companyName || "");
      setValue("addProduct.0.companyAddress", state?.companyAddress || "");
      setValue("addProduct.0.gstNumber", state?.gstNumber || "");
      setValue("addProduct.0.stock", state?.stock || "");
      // setValue(
      //   "addProduct.0.highLevelCustomer",
      //   state?.highLevelCustomer || ""
      // );
      // setValue("addProduct.0.midLevelCustomer", state?.midLevelCustomer || "");
      // setValue("addProduct.0.lowLevelCustomer", state?.lowLevelCustomer || "");
      // setValue("addProduct.0.others", state?.others || "");
      // setValue(
      //   "addProduct.0.manufacturingDate",
      //   state?.manufacturingDate
      //     ? moment(state?.manufacturingDate).format("YYYY-MM-DD")
      //     : ""
      // );
      // setValue(
      //   "addProduct.0.expiryDate",
      //   state?.expiryDate ? moment(state?.expiryDate).format("YYYY-MM-DD") : ""
      // );
    }
  }, [state, setValue]);

  // Watch quantity value
  const quantity = useWatch({ control, name: "quantity" });

  useEffect(() => {
    if (quantity === 0 || quantity === "0" || quantity === "") {
      setValue("stock", "Out Of Stock");
    } else {
      setValue("stock", "Available");
    }
  }, [quantity, setValue]);

  // FORM DATA
  const onSubmit = (data) => {
    const formDataArray = data?.addProduct || [];

    if (state?.id) {
      // Submit a single product (first item in array)
      const firstProduct = formDataArray[0];
      const editData = {
        productNameEnglish: firstProduct?.productNameEnglish || "",
        productImage: firstProduct?.productImage || null,
        discountOnUnitPrice: firstProduct?.discountOnUnitPrice || null,
        offerSelectFromTo: firstProduct?.offerSelectFromTo || null,
        unitPrice: firstProduct?.unitPrice || 0,
        quantity: firstProduct?.quantity || 0,
        actualUnitPrice: firstProduct?.actualUnitPrice || null,
        stock: firstProduct?.stock || "",
        quantityType: firstProduct?.quantityType || null,
        otherQuantityType: firstProduct?.otherQuantityType || null,
        gstAmount: firstProduct?.gstAmount || null,
        highLevelCustomer: firstProduct?.highLevelCustomer || "",
        midLevelCustomer: firstProduct?.midLevelCustomer || "",
        lowLevelCustomer: firstProduct?.lowLevelCustomer || "",
        others: firstProduct?.others || "",
        hsnCode: firstProduct?.hsnCode || null,
        productFor: firstProduct?.productFor || "",
        mrpPrice: firstProduct?.mrpPrice || null,
        manufacturingDate: firstProduct?.manufacturingDate || null,
        expiryDate: firstProduct?.expiryDate || null,
      };
      updateApi(editData); // single item update
    } else {
      mutate(formDataArray); // submit full array
    }
  };

  return (
    <>
      <div className="form_main_block">
        <div className="form_sub_block">
          <form className="p-4" onSubmit={handleSubmit(onSubmit)}>
            {fields?.map((field, index) => {
              return (
                <>
                  <div key={field?.id}>
                    <div className="row px-3 d-flex gap-3 my-2">
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">
                          Product Name<span style={{ color: "red" }}>*</span>
                        </label>
                        <Controller
                          name={`addProduct.${index}.productNameEnglish`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Product is required" }}
                          render={({ field, fieldState: error }) => (
                            <>
                              <input
                                {...field}
                                type="text"
                                placeholder="Product Name"
                                className="product_input_field"
                              />
                              {error && (
                                <p className="text-danger small">
                                  {error?.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">HSN Code</label>
                        <Controller
                          name={`addProduct.${index}.hsnCode`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <input
                                {...field}
                                type="text"
                                placeholder="HSN"
                                className="product_input_field"
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Company Name</label>
                        <Controller
                          name={`addProduct.${index}.companyName`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <input
                                {...field}
                                type="text"
                                placeholder="Company Name"
                                className="product_input_field"
                              />
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Address</label>
                        <Controller
                          name={`addProduct.${index}.companyAddress`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <>
                              <input
                                {...field}
                                type="text"
                                placeholder="Address"
                                className="product_input_field"
                              />
                            </>
                          )}
                        />
                      </div>
                      {/* <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">
                          Purchase Price
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Controller
                          name={`addProduct.${index}.unitPrice`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Price is required" }}
                          render={({ field, fieldState: { error } }) => (
                            <>
                              <input
                                {...field}
                                type="number"
                                step="any"
                                placeholder="Unit Price"
                                className="product_input_field"
                              />
                              {error && (
                                <p className="text-danger small">
                                  {error?.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">
                          Quantity<span style={{ color: "red" }}>*</span>
                        </label>
                        <Controller
                          name={`addProduct.${index}.quantity`}
                          control={control}
                          defaultValue=""
                          rules={{ required: "Quantity is required" }}
                          render={({ field, fieldState: error }) => (
                            <>
                              <input
                                {...field}
                                type="number"
                                step="any"
                                placeholder="Quantity"
                                className="product_input_field"
                              />
                              {error && (
                                <p className="text-danger small">
                                  {error?.message}
                                </p>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Quantity Type</label>
                        <Controller
                          name={`addProduct.${index}.quantityType`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <select {...field} className="product_input_field" >
                              <option value="">Select Quantity Type</option>
                              <option value="PCS">PCS</option>
                              <option value="KG">KG</option>
                              <option value="LTR">LTR</option>
                              <option value="G">G</option>
                              <option value="BOX">BOX</option>
                              <option value="BOXES">BOXES</option>
                              <option value="Other">Other</option>
                            </select>
                          )}
                        />
                      </div>
                      {quantityType == "Other" ? (
                        <>
                          <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                            <label className="executive_label">
                              Other Quantity Type
                            </label>
                            <Controller
                              name={`addProduct.${index}.otherQuantityType`}
                              control={control}
                              defaultValue=""
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Other Quantity Type"
                                  className="product_input_field"
                                />
                              )}
                            />
                          </div>
                        </>
                      ) : (
                        <></>
                      )} */}
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Gst Number</label>
                        <Controller
                          name={`addProduct.${index}.gstNumber`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="GST"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Product For</label>
                        <Controller
                          name={`addProduct.${index}.productFor`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <select {...field} className="product_input_field">
                              <option value=""> Product For </option>
                              <option value="Sales">Sales</option>
                              <option value="Purchase">Purchase</option>
                              <option value="Both">Both</option>
                            </select>
                          )}
                        />
                      </div>

                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Stock</label>
                        <Controller
                          name={`addProduct.${index}.stock`}
                          control={control}
                          defaultValue="Available"
                          render={({ field }) => (
                            <select {...field} className="product_input_field">
                              <option value=""> Stock </option>
                              <option value="Available">Available</option>
                              <option value="Out of Stock">Out Of Stock</option>
                            </select>
                          )}
                        />
                      </div>
                      {state?.id ? (
                        <></>
                      ) : (
                        <>
                          <div
                            className="col-12 col-md-2 d-flex  justify-content-start align-items-end gap-2 mb-1 p-0"
                            style={{ width: "8%" }}
                            onClick={() => {
                              append({
                                productNameEnglish: "",
                                productImage: "",
                                discountOnUnitPrice: "",
                                offerSelectFromTo: "",
                                unitPrice: "",
                                quantity: "",
                                actualUnitPrice: "",
                                stock: "Available",
                                quantityType: "",
                                otherQuantityType: "",
                                hsnCode: "",
                                gstAmount: "",
                                highLevelCustomer: "",
                                midLevelCustomer: "",
                                lowLevelCustomer: "",
                                others: "",
                                productFor: "",
                                mrpPrice: "",
                                manufacturingDate: "",
                                expiryDate: "",
                                companyName: "",
                                companyAddress: "",
                                gstNumber: "",
                              });
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                cursor: "pointer",
                              }}
                            >
                              {" "}
                              <img
                                src={Images?.orderAdd}
                                alt="no-image"
                                className="image_icon"
                              />
                            </div>
                          </div>
                          {index > 0 ? (
                            <>
                              <button
                                onClick={() => {
                                  remove(index);
                                }}
                                style={{
                                  border: "none",
                                  borderRadius: "5px",
                                  height: "35px",
                                  fontWeight: "bolder",
                                  background: "grey",
                                }}
                              >
                                Remove
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                      {/* <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">
                          Manufacturing Date
                        </label>
                        <Controller
                          name={`addProduct.${index}.manufacturingDate`}
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              maxDate={new Date()}
                              placeholderText="YYYY-MM-DD"
                              dateFormat="yyyy-MM-dd"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                        <label className="executive_label">Expiry Date</label>
                        <Controller
                          name={`addProduct.${index}.expiryDate`}
                          control={control}
                          defaultValue={null}
                          render={({ field }) => (
                            <DatePicker
                              {...field}
                              selected={field.value}
                              onChange={(date) => field.onChange(date)}
                              minDate={watch(
                                `addProduct.${index}.manufacturingDate`
                              )}
                              placeholderText="YYYY-MM-DD"
                              dateFormat="yyyy-MM-dd"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div> */}
                    </div>
                    <div className="row px-3 d-flex gap-3 my-4">
                      {/* <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          High Level Customer
                        </label>
                        <Controller
                          name={`addProduct.${index}.highLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>

                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          Mid Level Customer
                        </label>
                        <Controller
                          name={`addProduct.${index}.midLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">
                          Low Level Customer
                        </label>
                        <Controller
                          name={`addProduct.${index}.lowLevelCustomer`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div>
                      <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-1 p-0">
                        <label className="executive_label">Others</label>
                        <Controller
                          name={`addProduct.${index}.others`}
                          control={control}
                          defaultValue=""
                          render={({ field }) => (
                            <input
                              {...field}
                              type="text"
                              placeholder="00.00"
                              className="product_input_field"
                            />
                          )}
                        />
                      </div> */}
                    </div>
                  </div>
                </>
              );
            })}

            {/* <div className="row px-3 d-flex gap-3 my-2">
              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">
                  Product Name<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="productNameEnglish"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Product is required" }}
                  render={({ field, fieldState: error }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="Product Name"
                        className="product_input_field"
                      />
                      {error && (
                        <p className="text-danger small">{error?.message}</p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">HSN Code</label>
                <Controller
                  name="hsnCode"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <>
                      <input
                        {...field}
                        type="text"
                        placeholder="HSN"
                        className="product_input_field"
                      />
                    </>
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">
                  Purchase Price
                  <span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="unitPrice"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Price is required" }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="Unit Price"
                        className="product_input_field"
                      />
                      {error && (
                        <p className="text-danger small">{error?.message}</p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">
                  Quantity<span style={{ color: "red" }}>*</span>
                </label>
                <Controller
                  name="quantity"
                  control={control}
                  defaultValue=""
                  rules={{ required: "Quantity is required" }}
                  render={({ field, fieldState: error }) => (
                    <>
                      <input
                        {...field}
                        type="number"
                        step="any"
                        placeholder="Quantity"
                        className="product_input_field"
                      />
                      {error && (
                        <p className="text-danger small">{error?.message}</p>
                      )}
                    </>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">Quantity Type</label>
                <Controller
                  name="quantityType"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value="">Select Quantity Type</option>
                      <option value="pcs">PCS</option>
                      <option value="kg">KG</option>
                      <option value="ltr">LTR</option>
                      <option value="g">G</option>
                      <option value="Other">Other</option>
                    </select>
                  )}
                />
              </div>
              {quantityType == "Other" ? (
                <>
                  <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                    <label className="executive_label">
                      Other Quantity Type
                    </label>
                    <Controller
                      name="otherQuantityType"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <input
                          {...field}
                          type="text"
                          placeholder="Other Quantity Type"
                          className="product_input_field"
                        />
                      )}
                    />
                  </div>
                </>
              ) : (
                <></>
              )}

              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">Product For</label>
                <Controller
                  name="productFor"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value=""> Product For </option>
                      <option value="Sales">Sales</option>
                      <option value="Purchase">Purchase</option>
                      <option value="Both">Both</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column  mb-1 p-0">
                <label className="executive_label">Gst %</label>
                <Controller
                  name="gstAmount"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="number"
                      step="any"
                      placeholder="GST"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
            </div>
            <div className="row px-3 d-flex gap-3 my-4">
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Stock</label>
                <Controller
                  name="stock"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <select {...field} className="product_input_field">
                      <option value=""> Stock </option>
                      <option value="Available">Available</option>
                      <option value="Out Of Stock">Out Of Stock</option>
                    </select>
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">High Level Customer</label>
                <Controller
                  name="highLevelCustomer"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="00.00"
                      className="product_input_field"
                    />
                  )}
                />
              </div>

              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Mid Level Customer</label>
                <Controller
                  name="midLevelCustomer"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="00.00"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Low Level Customer</label>
                <Controller
                  name="lowLevelCustomer"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="00.00"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
              <div className="col-12 col-md-2 d-flex flex-column gap-2 mb-3 p-0">
                <label className="executive_label">Others</label>
                <Controller
                  name="others"
                  control={control}
                  defaultValue=""
                  render={({ field }) => (
                    <input
                      {...field}
                      type="text"
                      placeholder="00.00"
                      className="product_input_field"
                    />
                  )}
                />
              </div>
            </div> */}

            <div className="row px-3 my-4">
              <div className="col-12 col-md-2 p-0">
                <button className="product_form_submit_btn">
                  {postLoading || putLoading ? (
                    <>
                      <i class="fa fa-spinner fa-spin"></i>
                    </>
                  ) : (
                    <>Submit</>
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <PopupModel
        isOpen={isModalOpen}
        closePopup={closeModal}
        popupType={popupType}
        setPopupType={setPopupType}
        message="Product Added Successfully!"
        updatemessage="Product Updated Successfully!"
        state={state?.id}
        navigateUrl="/viewProduct"
      />
    </>
  );
};

export default AddProduct;
